/*
========================================================

Velora Product Engine v2.0
Sprint 3

Controls:

✓ Variant
✓ Price
✓ Inventory
✓ Add To Cart
✓ Hidden Variant

========================================================
*/

window.VeloraProduct = (function () {

    let selector = null;
    let hiddenVariant = null;
    let price = null;
    let addButton = null;

    function money(cents) {

        if (window.Shopify && Shopify.formatMoney) {

            return Shopify.formatMoney(
                cents,
                window.Shopify.money_format
            );

        }

        return "$" + (cents / 100).toFixed(2);

    }

    function update() {

        const option =
            selector.options[
                selector.selectedIndex
            ];

        //----------------------------------
        // Hidden Variant
        //----------------------------------

        hiddenVariant.value =
            option.value;

        //----------------------------------
        // Price
        //----------------------------------

        price.innerHTML =
            money(
                Number(option.dataset.price)
            );

        //----------------------------------
        // Availability
        //----------------------------------

        if (option.dataset.available === "true") {

            addButton.disabled = false;

            addButton.innerHTML =
                "Add to Cart";

        } else {

            addButton.disabled = true;

            addButton.innerHTML =
                "Sold Out";

        }

        //----------------------------------
        // Tell Gallery
        //----------------------------------

        if (window.VeloraGallery) {

            VeloraGallery.updateFromVariant(
                option
            );

        }

    }

    function init() {

        selector =
            document.getElementById(
                "vblVariantSelect"
            );

        hiddenVariant =
            document.getElementById(
                "vblVariantId"
            );

        price =
            document.getElementById(
                "vblProductPrice"
            );

        addButton =
            document.querySelector(
                ".vbl-add-cart"
            );

        if (!selector) return;

        selector.addEventListener(
            "change",
            update
        );

        update();

    }

    return {

        init

    };

})();

document.addEventListener(

    "DOMContentLoaded",

    function () {

        VeloraProduct.init();

    }

);